import { FaqSection } from '@mc/educator-design-system'
import { useProgramFaqItems } from '../../../../components/Faq'
import { useFireEvent } from '../../../../tracking/educatorTracking'

export const SubjectFaqSection = () => {
  const { headline, items } = useProgramFaqItems()
  const fireEvent = useFireEvent()

  return (
    <FaqSection
      headline={headline}
      items={items}
      onItemExpand={(question) =>
        fireEvent('educatorSignClick', { action: question, location: 'faq' })
      }
    />
  )
}
